module.exports = __webpack_public_path__ + "static/paypal-logo-small-1b118a783f8a68d7c204822d5945dbec.svg";